module.exports = __webpack_public_path__ + "static/media/Icon__World.3f541f9d.png";